import React from 'react'

import PortfolioSubmenu from "./submenu/submenu"
import ErrorBoundary from "../../../../core/error-boundary"
import PortfolioHeaderTitle from "./title/header-title"
import PortfolioHeaderQuickControls from "./quick-controls/quick-controls"

type Props = {
    app     : any
}

export default class PortfolioHeader extends React.Component<Props> {

    componentDidMount() {
        gd.bus.subscribe('top:header-update', this, this.update)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    update = () => {this.forceUpdate()}

    render() {
        return (
            <div className="ui5-app-header with-menu portfolio-header">
                <div className="left">
                    <ErrorBoundary>
                        <PortfolioHeaderTitle />
                    </ErrorBoundary>
                </div>
                <PortfolioHeaderQuickControls app={this.props.app}/>

                <PortfolioSubmenu />
            </div>
        )
    }
}